import { useEffect } from "react"
import { useNavigate } from "react-router-dom"

import { useAppDispatch, useAppSelector } from "lib/hooks"
import { selectConversation } from "reducers/conversations/conversations.reducer"
import { clearPendingErrand } from "reducers/selected"

// This component tracks if there is any pending errand (assigned to uourself) and redirects if it arrives in store
// It's done this way as we rely on webscoekts and it might take few moments to get the assigned message
const ErrandNavigationWatcher = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  const pendingErrandId = useAppSelector(state => state.selected.pendingErrandId)
  const conversation = useAppSelector(selectConversation)

  useEffect(() => {
    if (!pendingErrandId) return

    if (conversation) {
      navigate("/")
      dispatch(clearPendingErrand())
    }
  }, [conversation, dispatch, navigate, pendingErrandId])

  return null
}

export default ErrandNavigationWatcher
